<template>
    <div class="video-wrapper" :class="{'iframe-wrapper': isIframe}">
        <video width="100%" height="100%" controls v-if="!isIframe" :poster='videoPostersrc'>
          <source :src='videosrc' type="video/mp4">
        </video>
        <iframe :src="iframesrc" v-if="isIframe" width="100%" height="100%"></iframe>
    </div>
</template>

<script>
  export default {
    name: 'video-wrapper',
    props: ['blockdata'],
    data() {
      return {
        videosrc: this.blockdata.file.url,
        videoPostersrc: this.blockdata.poster,
        isIframe: this.blockdata.isIframe,
        iframesrc: this.blockdata.iframe
      }
    },
    methods: {
      parseUrl: function(url){
          return "//player.vimeo.com/video/" + url.match(/http:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/)[2];
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VideoWrapper.vue?2e2bc502